export default __webpack_public_path__ + "static/media/ligentia-logo.b64d984c.svg";